/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const imprintStyle = {
  impressum: (theme: Theme)=> ({
    margin: "2rem 0",
    [theme.breakpoints.up("md")]: {
      margin: "5rem 0"
    }
  }),
};

export default imprintStyle;
